import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getServiceBanner } from "../../state/modules/serviceBanner/selectors";
import sanitizeMessage from "./sanitizeMessage";
import styles from "./index.css";

export const ServiceBanner = ({ serviceBanner }) => {
  if (!serviceBanner?.enabled || !serviceBanner.message) return null;

  const sanitizedMessage = sanitizeMessage(serviceBanner.message);

  if (!sanitizedMessage) return null;

  return (
    <div
      className={styles.container}
      role="region"
      aria-label="Service information"
      data-testid="service-banner"
    >
      <p
        className={styles.body}
        dangerouslySetInnerHTML={{
          __html: sanitizedMessage,
        }}
      />
    </div>
  );
};

ServiceBanner.propTypes = {
  serviceBanner: PropTypes.shape({
    enabled: PropTypes.bool,
    message: PropTypes.string,
  }),
};

const ConnectedServiceBanner = () => {
  const serviceBanner = useSelector(getServiceBanner);

  return <ServiceBanner serviceBanner={serviceBanner} />;
};

export default ConnectedServiceBanner;
